export const MIN_MOBIEL_WINDOW_WIDTH = 320;
export const MAX_MOBILE_WINDOW_WIDTH = 768;